// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ({"96":"csw-frame","289":"csw-widget","315":"csw-ae","600":"csw-vendor-webfontloader","677":"csw-vendor-dompurify"}[chunkId] + ".5.4.35.js");